export const useClock = () => {
  const weekDay = ref('') // in Dutch
  const day = ref('')
  const month = ref('') // in Dutch
  const year = ref('')
  const hour = ref('00')
  const minutes = ref('00')
  const seconds = ref('00')

  const updateClock = () => {
    const date = new Date()
    weekDay.value = date.toLocaleDateString('nl-NL', { weekday: 'long' })
    day.value = date.getDate().toString()
    month.value = date.toLocaleDateString('nl-NL', { month: 'long' })
    year.value = date.getFullYear().toString()
    hour.value = date.getHours().toString().padStart(2, '0')
    minutes.value = date.getMinutes().toString().padStart(2, '0')
    seconds.value = date.getSeconds().toString().padStart(2, '0')
  }

  updateClock()

  const interval = setInterval(updateClock, 1000)

  const tearDownClock = () => {
    clearInterval(interval)
  }

  return { weekDay, day, month, year, hour, minutes, seconds, tearDownClock }
}
